import { GroupAdapter } from '../../../app/groups';
import { GroupsImplConfig } from './groupConfig';

export function createGroupsImpl(
    config: GroupsImplConfig
): GroupAdapter {
    const { api } = config;
    return {
        async find(context, query) {
            const response = await api.groups.list(context, query);
            let acc = response.data;

            return {
                limit: response.pagination?.page_size || acc.length,
                total: acc.length + (response.pagination?.count_left || 0),
                items: acc,
            };
        },
        create(context, entity) {
            return api.groups.create(context, entity)
        },
        remove(context, entity) {
            return api.groups.remove(context, entity)
        },
    };
}
